module.exports = __webpack_public_path__ + "img/city (2).3999b97c.png";